import invariant from 'tiny-invariant';
import { useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { RingComplianceReportFilterData } from 'business/quality-control/pages/ring-compliance-report/types';
import { toPercent } from 'technical/utils/converter';

const DECIMAL_DIGITS = 1;

const getPercentage = (value: number, totalRings: number, locale: string) => {
  if (value === 0 || totalRings === 0) {
    return (0).toLocaleString(locale);
  }

  return toPercent(value / totalRings).toLocaleString(locale, {
    maximumFractionDigits: DECIMAL_DIGITS,
  });
};

export function RingComplianceSelectedCount({
  filterData,
}: {
  filterData: RingComplianceReportFilterData | null;
}) {
  const { currentConstructionSite } = useAppContext();
  invariant(currentConstructionSite, 'No construction site');

  const { t, language } = useTranslation();

  if (!currentConstructionSite.isQualityValidatorActivated) {
    return (
      <>
        {t(
          'qualityControl.ringComplianceReport.selectedItemsWhithoutValidation',
          {
            selectedRings: filterData?.selectedRings,
            waitingRings: getPercentage(
              filterData?.waitingRings ?? 0,
              filterData?.selectedRings ?? 0,
              language,
            ),
            compliantRings: getPercentage(
              filterData?.compliantRings ?? 0,
              filterData?.selectedRings ?? 0,
              language,
            ),
          },
        )}
      </>
    );
  }

  return (
    <>
      {t('qualityControl.ringComplianceReport.selectedItems', {
        selectedRings: filterData?.selectedRings,
        waitingRings: getPercentage(
          filterData?.waitingRings ?? 0,
          filterData?.selectedRings ?? 0,
          language,
        ),
        compliantRings: getPercentage(
          filterData?.compliantRings ?? 0,
          filterData?.selectedRings ?? 0,
          language,
        ),
        approvedRings: getPercentage(
          filterData?.approvedRings ?? 0,
          filterData?.selectedRings ?? 0,
          language,
        ),
        refusedRings: getPercentage(
          filterData?.refusedRings ?? 0,
          filterData?.selectedRings ?? 0,
          language,
        ),
      })}
    </>
  );
}
